import { render } from "./Team_manager_en.vue?vue&type=template&id=b8fc32da&scoped=true"
import script from "./Team_manager_en.vue?vue&type=script&lang=js"
export * from "./Team_manager_en.vue?vue&type=script&lang=js"

import "./Team_manager_en.vue?vue&type=style&index=0&id=b8fc32da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b8fc32da"

export default script